import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Link } from '@tanstack/react-router';

export function LoggedOutView() {
  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center bg-muted/40 p-4 sm:p-6 md:p-8">
      {/* Top-left logo */}
      <div className="absolute left-4 top-4 md:left-8 md:top-8">
        <Link
          to="/"
          className="text-xl font-semibold tracking-tight text-foreground hover:text-primary"
        >
          Trapeze
        </Link>
      </div>

      <div className="w-full max-w-sm space-y-6 sm:max-w-md">
        {' '}
        {/* Adjusted max-w for responsiveness */}
        <div className="text-left">
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-50 sm:text-4xl">
            Welcome back!
          </h1>
        </div>
        <Card className="w-full shadow-lg">
          <CardHeader className="pb-4">
            {' '}
            {/* Reduced bottom padding for header */}
            <CardTitle className="text-2xl font-semibold">Sign into Trapeze</CardTitle>
            {/* Optional: CardDescription could go here if needed */}
            {/* e.g., <CardDescription>Access your account to continue.</CardDescription> */}
          </CardHeader>
          <CardContent className="pt-2">
            {' '}
            {/* Adjusted top padding for content */}
            <Button asChild className="w-full" size="lg">
              <Link to="/login/$">Continue with email</Link>
            </Button>
          </CardContent>
          <CardFooter className="flex items-center justify-start border-t px-6 py-4 text-sm">
            {' '}
            {/* Added border-t and padding */}
            <p className="text-muted-foreground">
              Don't have an account?{' '}
              <a
                href="mailto:support@trapezehealth.com" // Changed to a more generic support link
                className="font-medium text-primary underline-offset-4 hover:underline"
              >
                Contact support
              </a>
            </p>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
